require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./centre-sportif-1-1-13.json") })
        }
      }, "path---centre-sportif-1-1-13");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---centre-sportif-1-1-13!./.cache/json/centre-sportif-1-1-13.json
// module id = 364
// module chunks = 231608221292675